import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface SheetProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
}
export function Sheet({
  open,
  onClose,
  title,
  description,
  children
}: SheetProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-701" data-mp="2wtqpuqe45u9r">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center md:items-center md:p-6" data-id="element-702" data-mp="2wusbfosr9z5q">
          <motion.div className="absolute inset-0 bg-ink-900/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} aria-hidden data-id="element-703" data-mp="2sq2io8te90p1" />
          <motion.div role="dialog" aria-modal="true" aria-label={title} initial={{
        y: 40,
        opacity: 0,
        scale: 0.98
      }} animate={{
        y: 0,
        opacity: 1,
        scale: 1
      }} exit={{
        y: 40,
        opacity: 0,
        scale: 0.98
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative max-h-[92vh] w-full overflow-y-auto rounded-t-3xl bg-white p-5 pb-8 shadow-lift md:max-w-lg md:rounded-3xl md:p-7" data-id="element-704" data-mp="k9z53et5197g">
            <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-ink-200 md:hidden" aria-hidden data-id="element-705" data-mp="5m4a1rrnqsr7" />
            <div className="mb-5 flex items-start gap-4" data-id="element-706" data-mp="aj4l6h3d6lp6">
              <div className="flex-1" data-id="element-707" data-mp="fbxpx4yu1u19">
                <h2 className="text-lg font-semibold tracking-tight text-ink-900" data-id="element-708" data-mp="fcyy91ogs2fa">{title}</h2>
                {description && <p className="mt-1 text-sm text-ink-500" data-id="element-709" data-mp="3e14lrb6lbosr">{description}</p>}
              </div>
              <button onClick={onClose} className="grid h-9 w-9 place-items-center rounded-full text-ink-500 transition-colors duration-150 hover:bg-ink-100" aria-label="Close" data-id="element-710" data-mp="3iyo9d1p6hdxd">
                <XIcon className="h-4 w-4" data-id="element-711" data-mp="yy2p57tw6rgu" />
              </button>
            </div>
            {children}
          </motion.div>
        </div>}
    </AnimatePresence>;
}